import React, {useEffect, useState} from 'react';
import styles from './BalanceBillContent.module.scss'
import {useSelector} from "react-redux";
import BalanceAccount from "./BalanceAccount";
import {Invoice} from "../../../services";
import { t } from "i18next";


const BalanceBillContent = ( ) => {
    const {user} = useSelector(state => state);
    const [account, setAccount] = useState(null);

    const entityId = user.companyId === null ? user.id : user.companyId;

    useEffect(() => {
        if (user && user.id) {
            Invoice.getBalanceInfo(entityId).then((response) => {
                console.log('Invoices responce', response.data);
                if(response.status == 200) {
                    setAccount(response.data)
                }
            }).catch(error => {
                console.log(error);
            })
        }
    }, [user]);

    const formattedDate = account?.filled ? new Date(account.filled).toLocaleDateString('ru-RU') : t('balanceList.unknown');

    return (
        <div className={styles['balance__content']}>
            <BalanceAccount
                icon={(<img src="/icons/balance-status/paid.svg" />)}
                // quantity={accounts?.filled || 0}
                quantity={t('balanceList.replenished') + formattedDate}
                title={t('balanceList.available')}
                bill={user?.balance}
                className={styles['balance__item']}
            />
            <BalanceAccount
                icon={(<img src="/icons/balance-status/onHold.svg" />)}
                // quantity={accounts?.onHoldOrdersCount || 0}
                quantity={account?.onHoldOrdersCount + " " + t('balanceList.orders')}
                title={t('balanceList.hold')}
                bill={user?.moneyOnHold}
                className={styles['balance__item']}
            />
            <BalanceAccount
                icon={(<img src="/icons/balance-status/paid.svg" />)}
                // quantity={accounts?.totalPaidOrdersCount || 0}
                quantity={account?.totalPaidOrdersCount + " " + t('balanceList.orders')}
                title={t('balanceList.totalPaid')}
                bill={user?.totalPaid}
                className={styles['balance__item']}
            />
            <div style={{
                display: "flex",
                justifyContent: "end",
                flex: "1",
                marginBottom: "20px"
            }}>
            </div>
        </div>
    );
};

export default BalanceBillContent;